export class WhatsappServiceStub {
    sendWhatsapp() { }
}
